module.exports = "<app-pratiche-tabs [row]=\"pratica\" [writePermission]=\"writePermission\" (newRate)=\"openNewRate($event)\"></app-pratiche-tabs>\n"